import { config } from '@/src/config/app-config';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Button, ColumnLayout, Grid, GridProps, Link, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useUser } from '@/src/store/user.context';
import { SKILL_BUILDER_LEARN_URL } from '@/src/constants/common';
import { BOOK_EVENT_STEPS, BookEventStep } from './book-event-steps.config';
import './BookEventSteps.scss';

const BookEventSteps: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useUser();
  const canCreateEvents = user?.canScheduleAnEvent;
  const colspan: GridProps.BreakpointMapping = { xl: 4, l: 4, m: 4, s: 4, xs: 12, xxs: 12 };

  if (!canCreateEvents) {
    return (
      <SpaceBetween size={'s'} alignItems="center" direction="vertical">
        <div className="bookevent-steps-container">
          <Box variant="h2" textAlign="center" color="inherit" fontSize="display-l">
            {t(i18nKeys.catalog.bookEventSteps.noPermission.title)}
          </Box>
          <Box variant="p" textAlign="center" color="inherit" padding={{ top: 'm', bottom: 'm' }}>
            {t(i18nKeys.catalog.bookEventSteps.noPermission.message)}
          </Box>
          <Box textAlign="center">
            <Button variant="primary" href={SKILL_BUILDER_LEARN_URL} target="_blank" iconName="external">
              {t(i18nKeys.catalog.bookEventSteps.noPermission.cta)}
            </Button>
          </Box>
        </div>
      </SpaceBetween>
    );
  }

  return (
    <SpaceBetween size={'s'} alignItems="center" direction="vertical">
      <div className="bookevent-steps-container">
        <Box variant="h2" textAlign="center" color="inherit" fontSize="display-l">
          {t(i18nKeys.catalog.bookEventSteps.title)}
        </Box>
        <ColumnLayout borders="horizontal" columns={1}>
          <div className="steps-containter">
            <Grid gridDefinition={[{ colspan }, { colspan }, { colspan }]}>
              {BOOK_EVENT_STEPS.map((step: BookEventStep) => (
                <div key={step.title} className="step">
                  <div className="step__item">
                    <div className="step__item__image">
                      <img src="assets/book-event-background.png" className={step.background} alt="" />
                      <img src={step.image} className={step.imageClass} alt="" />
                    </div>
                  </div>
                  <Box color="inherit" variant="h3" textAlign="left">
                    {t(step.title)}
                  </Box>
                  <Box color="inherit" data-classname="step__item__subtitle" textAlign="left" margin={{ left: 'xxxs' }}>
                    {step.link && step.linkUrl && (
                      <Link onFollow={() => history.push(step?.linkUrl || '')}>{t(step.link)}</Link>
                    )}
                    {t(step.subtitle)}
                  </Box>
                </div>
              ))}
            </Grid>
          </div>
        </ColumnLayout>
      </div>
    </SpaceBetween>
  );
};

export default BookEventSteps;
